import { render, staticRenderFns } from "./label-allocation-modal.vue?vue&type=template&id=6bdb11c0"
import script from "./label-allocation-modal.vue?vue&type=script&lang=js"
export * from "./label-allocation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports